import React from 'react';

function MapMarkerIcon({ size, color = '#049B56' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 25"
    >
      <g clipPath="url(#clip0_4214_34013)">
        <path
          fill={color}
          d="M11.999 12.652a4 4 0 100-8 4 4 0 000 8zm0-6a2 2 0 110 4 2 2 0 010-4zm8.66 3.157l-.72-.239A7.999 7.999 0 0012 .652a7.993 7.993 0 00-7.914 9.092 5.046 5.046 0 00-2.548 1.3 4.946 4.946 0 00-1.538 3.608v4.075a5.013 5.013 0 003.6 4.8l2.87.9c.482.15.984.226 1.489.225a5.07 5.07 0 001.355-.186l5.78-1.71a2.988 2.988 0 011.573 0l2.387.8a4 4 0 004.946-3.883v-5.149a5.014 5.014 0 00-3.34-4.716v.001zM7.757 4.414a5.987 5.987 0 018.484 0 6.037 6.037 0 01.01 8.5L12.7 16.37a.992.992 0 01-1.39 0l-3.552-3.44a6.04 6.04 0 010-8.515zm14.242 15.26a1.992 1.992 0 01-.764 1.571 1.968 1.968 0 01-1.626.395l-2.345-.788a5.024 5.024 0 00-2.717-.016l-5.784 1.708a3 3 0 01-1.694-.029l-2.894-.9a3.013 3.013 0 01-2.176-2.888v-4.075a2.964 2.964 0 01.92-2.163 3.025 3.025 0 011.669-.806 8.02 8.02 0 001.765 2.67l3.567 3.452a2.983 2.983 0 004.174 0l3.563-3.463a7.96 7.96 0 001.813-2.82l.537.177a3.006 3.006 0 011.992 2.825v5.15z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4214_34013">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(0 .652)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default MapMarkerIcon;
